import React from "react";
import { connect } from "react-redux";
import {
  DateTimePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { cmsActions } from "../store/actions/cms/cms.action";
import SystemLabel from "../system/SystemLabel/SystemLabel";

const JirangoDatePicker = ({ value, dispatch, handleChange, path }) => {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDateTimePicker
        className="jir-datepicker"
        clearable
        ampm={false}
        defaultValue={null}
        onOpen={() => dispatch(cmsActions.blockDeselect(true))}
        onClose={() => cmsActions.blockDeselect(false)}
        onChange={(e) => handleChange(e)}
        value={value ? new Date(value) : null}
        onError={(err) => console.error(err)}
        format="yyyy-MM-DD HH:mm:ss"
        cancelLabel={<SystemLabel name="Cancel" />}
        clearLabel={<SystemLabel name="Clear" />}
      />
    </MuiPickersUtilsProvider>
  );
};
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps)(JirangoDatePicker);
